import React from 'react';

const ChevronLeft = () => {
  return <svg width="11" height="10" viewBox="5 5 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ChevronLeft">
      <path id="Vector" fillRule="evenodd" clipRule="evenodd"
            d="M13.2068 5.29279C13.3943 5.48031 13.4996 5.73462 13.4996 5.99979C13.4996 6.26495 13.3943 6.51926 13.2068 6.70679L9.91379 9.99979L13.2068 13.2928C13.3889 13.4814 13.4897 13.734 13.4875 13.9962C13.4852 14.2584 13.38 14.5092 13.1946 14.6946C13.0092 14.88 12.7584 14.9852 12.4962 14.9875C12.234 14.9897 11.9814 14.8889 11.7928 14.7068L7.79279 10.7068C7.60532 10.5193 7.5 10.265 7.5 9.99979C7.5 9.73462 7.60532 9.48031 7.79279 9.29279L11.7928 5.29279C11.9803 5.10532 12.2346 5 12.4998 5C12.765 5 13.0193 5.10532 13.2068 5.29279Z"
            fill="black" fillOpacity="0.3"/>
    </g>
  </svg>
}

export default ChevronLeft;
